<div *ngIf="isLoading" class="loading-overlay">
    <div class="loading"></div>
</div>

<div class="responses-and-search-container">
    <div class="response-search-container">
        <div class="response-search">
            <input placeholder=" Find response" [(ngModel)]="searchString" name="searchString" (keypress)="checkForEnterKey($event)" class="response-search-input">
            <button class="response-search-button" (click)="search()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" width="14px" height="14px" style="fill: #b8b8b8;">
                    <path d="M15.7574 14.7187L11.5687 10.5312C12.4752 9.42187 12.9754 8.025 12.9754 6.5C12.9754 2.90937 10.0643 0 6.47362 0C2.88297 0 0 2.91031 0 6.5C0 10.0897 2.91079 13 6.47362 13C7.99871 13 9.39784 12.4716 10.506 11.5925L14.6946 15.78C14.8696 15.9281 15.0634 16 15.2541 16C15.4448 16 15.638 15.9267 15.7846 15.7803C16.0762 15.4875 16.0762 15.0125 15.7574 14.7187ZM1.50041 6.5C1.50041 3.74312 3.74414 1.5 6.50175 1.5C9.25937 1.5 11.5031 3.74312 11.5031 6.5C11.5031 9.25687 9.25937 11.5 6.50175 11.5C3.74414 11.5 1.50041 9.25625 1.50041 6.5Z"></path>
                </svg>
            </button>
        </div>
        <div *ngIf="selectedLibraryIndex !== -1" class="response-back-container">
            <a href="javascript:void(0)" (click)="backToLibrary()" class="response-back-link">< Back to canned responses</a>
        </div>
    </div>

    <div class="responses-container">
        <div *ngIf="selectedLibraryIndex === -1">
            <a *ngFor="let libraryResponse of libraryResponses; let n = index;" href="javascript:void(0)" (click)="librarySelected(n)" class="library-response">
                <span class="library-response-number">{{n+1}}</span>
                <span class="library-response-name">{{libraryResponse.library.name}}</span>
            </a>
        </div>

        <div *ngIf="selectedLibraryIndex !== -1">
            <p *ngIf="selectedLibraryIndex > -1" class="library-header">{{libraryResponses[selectedLibraryIndex].library.name}}</p>
            <div *ngIf="selectedLibraryIndex === -2" style="border-bottom: 1px solid #ddd;">
                <p class="search-results-header">{{cannedResponses.length}} results</p>
            </div>
            <div *ngFor="let cannedResponse of cannedResponses; let n = index;">
                <div class="library-response">
                    <button
                        class="number-or-arrow"
                        type="button"
                        (click)="applyResponse(n)"
                    >
                        <span class="library-response-number" [ngClass]="n === selectedResponseIndex ? 'selected' : ''">{{cannedResponse.response.name | slice:0:1}}</span>
    
                        <span class="library-response-arrow" [ngClass]="n === selectedResponseIndex ? 'selected' : ''">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -256 1792 1792" width="16px" height="16px" >
                                <g transform="matrix(1,0,0,-1,98.711864,1224.678)">
                                    <path d="M 1536,640 V 512 q 0,-53 -32.5,-90.5 Q 1471,384 1419,384 H 715 L 1008,90 q 38,-36 38,-90 0,-54 -38,-90 l -75,-76 q -37,-37 -90,-37 -52,0 -91,37 L 101,486 q -37,37 -37,90 0,52 37,91 l 651,650 q 38,38 91,38 52,0 90,-38 l 75,-74 q 38,-38 38,-91 0,-53 -38,-91 L 715,768 h 704 q 52,0 84.5,-37.5 Q 1536,693 1536,640 z"
                                    style="fill:currentColor"/>
                                </g>
                            </svg>
                        </span>
                    </button>

                    <a href="javascript:void(0)" (click)="responseSelected(n)" class="library-response-name response-name">{{cannedResponse.response.name}}</a>
                </div>

                <div *ngIf="n === selectedResponseIndex" class="response-detail-container">
                    <div *ngIf="selectedLibraryIndex === -2" class="response-detail-header">
                        {{cannedResponses[selectedResponseIndex].libraryName}}
                        <!-- {{libraryResponses[selectedLibraryIndex].library.name}} -->
                    </div>
                    <span class="response-detail">
                        {{cannedResponses[selectedResponseIndex].response.texts?.[0]?.content}}
                    </span>
                </div>
            </div>
        </div>
    </div>
    
</div>
